(() => {
  const SECTION_SELECTOR = '[data-personalize-engrave-section]';
  const INPUT_SELECTOR = 'input[type="text"]';
  const PREVIEW_SELECTOR = '[data-kan251-bottle-preview]';
  const TOP_GUTTER = 8;
  const BOTTOM_GUTTER = 12;
  const scheduled = new Set();

  function activePersonalizationInput() {
    const input = document.activeElement;
    if (!(input instanceof HTMLInputElement) || !input.matches(INPUT_SELECTOR)) {
      return null;
    }
    return input.closest(SECTION_SELECTOR) ? input : null;
  }

  function alignFocusedWorkspace() {
    const input = activePersonalizationInput();
    if (!input || window.innerWidth > 900) return;

    const viewport = window.visualViewport;
    const viewportHeight = viewport?.height || window.innerHeight;
    if (viewportHeight > 700) return;

    const section = input.closest(SECTION_SELECTOR);
    const scrollContainer = section?.parentElement;
    const helper = section?.querySelector('[class*="helper"]');
    const preview = [...(section?.querySelectorAll(PREVIEW_SELECTOR) || [])].find(
      (node) => node.getBoundingClientRect().width > 0,
    );
    if (!scrollContainer || !helper || !preview) return;

    const viewportTop = viewport?.offsetTop || 0;
    const viewportBottom = viewportTop + viewportHeight;
    const previewRect = preview.getBoundingClientRect();
    const helperRect = helper.getBoundingClientRect();
    let delta = 0;

    if (previewRect.top < viewportTop + TOP_GUTTER) {
      delta = previewRect.top - viewportTop - TOP_GUTTER;
    } else if (helperRect.bottom > viewportBottom - BOTTOM_GUTTER) {
      delta = helperRect.bottom - viewportBottom + BOTTOM_GUTTER;
    }

    if (Math.abs(delta) > 1) {
      scrollContainer.scrollBy({ top: delta, behavior: 'smooth' });
    }
  }

  function scheduleAlignment() {
    for (const timeout of scheduled) window.clearTimeout(timeout);
    scheduled.clear();

    for (const delay of [0, 80, 180, 320]) {
      const timeout = window.setTimeout(() => {
        scheduled.delete(timeout);
        alignFocusedWorkspace();
      }, delay);
      scheduled.add(timeout);
    }
  }

  document.addEventListener(
    'focusin',
    (event) => {
      if (event.target instanceof Element && event.target.closest(SECTION_SELECTOR)) {
        scheduleAlignment();
      }
    },
    true,
  );
  window.addEventListener('resize', scheduleAlignment, { passive: true });
  window.visualViewport?.addEventListener('resize', scheduleAlignment, { passive: true });
})();
